import { timezoneMoment } from 'common/functions';

export function formatBytes(bytes: number | undefined, decimals = 1): string {
  if (bytes === 0 || bytes === undefined) return '0 Bytes';
  const isNegative = bytes < 0;
  const bytesToFormat = isNegative ? -bytes : bytes;

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  const i = Math.floor(Math.log(bytesToFormat) / Math.log(k));

  return `${isNegative ? '-' : ''}${parseFloat((bytesToFormat / k ** i).toFixed(dm))} ${sizes[i]}`;
}

export function isVolumeLessThanPlanned(volume: string, plannedVolume: number): boolean {
  const size = volume.split(' ')[1];
  const volumeSize = volume.split(' ')[0];
  if (size === 'GB') {
    return parseFloat(volumeSize) <= plannedVolume;
  }
  return size === 'Bytes' || size === 'KB' || size === 'MB';
}

export function roundDailyVolume(volume: number): number {
  // if value is less than 1 show 2 decimal places; if less than 10 show one decimal place; otherwise round
  if (volume < 1) {
    return Math.round(volume * 100) / 100;
  }
  if (volume < 10) {
    return Math.round(volume * 10) / 10;
  }
  return Math.round(volume);
}

export function roundAverageVolume(volume: number): number {
  // if the average is less than 1 show 2 decimal points, otherwise truncate with no decimal points
  return volume < 1 ? Math.round(volume * 100) / 100 : Math.trunc(volume);
}

// use a standard format for dates on the billing page
export const formatBillingDate = (date: string | number, timezone: string | null): string =>
  timezoneMoment(timezone)(date).format('MMM D');

// use a standard format for search times in the Hindisight details dialog
export const formatSearchDate = (date: string | number, timezone: string | null): string =>
  timezoneMoment(timezone)(date).format('MMM D YYYY * h:mm:ss a');
